﻿const PaymentMethods = require('./PaymentMethods');
const URI = require('urijs');

module.exports = PaymentInfo;

function PaymentInfo({ $container, transactionId }) {
    let paypalPayment = $container.find('#paypal-payment');
    let cardInfo = $container.find('.card-info');
    let creditCardPayment = $container.find('#credit-card-payment');
    let selectedPaymentMethod = PaymentMethods.CARD;
    
    creditCardPayment.on('change', function () {
        $(this).addClass('checked');
        selectedPaymentMethod = PaymentMethods.CARD;
        paypalPayment.removeClass('checked');
        clearValidationErrors();
        cardInfo.removeClass('inactive');
    });

    paypalPayment.on('change', function () {
        $(this).addClass('checked');
        selectedPaymentMethod = PaymentMethods.PAYPAL;
        creditCardPayment.removeClass('checked');
        clearValidationErrors();
        cardInfo.addClass('inactive');
    });

    function clearValidationErrors() {
        $container.find('.required-input').css('border', '1px solid #939598');
        $container.find('p.required-warning').remove();
    }

    this.validateCardData = function () {
        clearValidationErrors();
        let requiredInputCard = $container.find('.required-input.card');

        if (selectedPaymentMethod !== PaymentMethods.CARD) {
            return true;
        }

        let validCreditCardData = true;
        for (let i = 0; i < requiredInputCard.length; i++) {

            if (!$(requiredInputCard[i]).val() || $(requiredInputCard[i]).val().length < 1) {
                $(requiredInputCard[i]).after('<p class="required-warning">required field</p>').css('border', '1px solid red');
                validCreditCardData = false;
            }
        }

        if ($('#security-code').val().length > 0 && $('#security-code').val().length !== 3 && $('#security-code').val().length !== 4) {
            $('#security-code').after('<p class="required-warning">CVV code should be 3 or 4 characters long</p>').css('border', '1px solid red');
            validCreditCardData = false;
        }

        if (!validCreditCardData || $('#credit-card-number').val().length < 1 || $('#expiration-month').val().length < 1 || $('#expiration-year').val().length < 1 || ($('#security-code').val().length !== 3 && $('#security-code').val().length !== 4)) {

            $('html, body').animate({
                scrollTop: form.offset().top - scrollOffset
            }, 500);
        }

        return validCreditCardData;
    }

    this.getDonationRequestData = function () {
        switch (selectedPaymentMethod) {
            case PaymentMethods.CARD: return {
                'card_cvv': $container.find('#security-code').val(),
                'card_exp_date_month': $container.find('#expiration-month').val(),
                'card_exp_date_year': $container.find('#expiration-year').val(),
                'card_number': $container.find('#credit-card-number').val(),
            }
            case PaymentMethods.PAYPAL: return {
                'extproc': 'paypal',
                'finish_success_redirect': `${window.location.href}?donationId=${transactionId}`,
                'finish_error_redirect': `${window.location.href}?error=true`
            };
            default: return {};
        }
    }

    this.getSelectedPaymentMethod = function () {
        return selectedPaymentMethod;
    }
}